var popup = document.getElementsByClassName("popup-event-background");
var popupRedirection = document.getElementsByClassName("popup-redirection-background");

var popupBlock = document.getElementsByClassName("popup-event");
var popupRedirectionBlock = document.getElementsByClassName("popup-redirection");

var exit = document.getElementsByClassName("exit");

var buttonActivePopUp = document.getElementsByClassName("active-popup");
var checkbox = document.getElementsByClassName("checkmark-basic");
var buttonSubmit = document.getElementsByClassName("event-submit");
var buttonReturn = document.getElementsByClassName("return-event");
var errorMessage = document.getElementsByClassName("cgu-not-accepted");
var isMailErrorDisplay = document.getElementById("mce-success-response");


let link = buttonActivePopUp[0].dataset.link;

function goToEvent() {
	
	setTimeout(function() {
		window.open(link,'_blank');
	}, 1500)
}

function checkInfo() {
	setTimeout(function() {

		if(isMailErrorDisplay.style.display !== "none") {
			popupRedirection[0].classList.remove('popup-event-hidden')
			popup[0].classList.add('popup-event-hidden')
			
			goToEvent()
		}
	}, 500)
	
}

checkbox[0].addEventListener('change', () =>
{
	if(checkbox[0].checked) {
		errorMessage[0].style.opacity = 0
	} else {
		errorMessage[0].style.opacity = 1
	}
})


buttonActivePopUp[0].addEventListener('click', () =>
{
	popup[0].classList.remove('popup-event-hidden')
})

buttonSubmit[0].addEventListener('click', () =>
{
	if(!checkbox[0].checked) {
		errorMessage[0].style.opacity = 1
	}

	if(checkbox[0].checked) {
		checkInfo();
	}
})



if(exit){
	exit[0].addEventListener('click', () =>
	{
		popup[0].classList.add('popup-event-hidden')	
	})
}

buttonReturn[0].addEventListener('click', () =>
{
	document.location.reload()
})